<template>
      <card>
 
        <list
              v-if="$store.state.user.is_root"
              :columns="columns"
              :modalCreate="modalCreate"
              :removeLink="removeLink"
              :cardLink="cardLink"
              :isUpdate="true"
              :isAdd="false"
              :itemLink="itemLink"
              :setLink="setLink"
              :openItem="true"
              :fields="fields"
              :searchDisable="false"
              @change="change"
              @changeFunction="changeFunction"
              v-model="val"
        />
      </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      val: [],
      modalCreate: "customer",
        fields: [
  
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_customer_cloud",
      itemLink: "customers",
      setLink: "customers",
      columns: [
 
     {
          key: "last_name",
          title: "Фамилия",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
     {
          key: "first_name",
          title: "Имя",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
     {
          key: "father_name",
          title: "Отчество",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "phone",
          title: "Номер телефона",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "is_root",
          title: "Суперпользователь",

        },
        {
          key: "created_at",
          title: "Создан",
          dateTimeFormat: true
        },
 
        {
          detail: true,
          remove: false,
        },
      ],
    };
  },
};
</script>
<style>
</style>
